module.exports = __webpack_public_path__ + "img/161.ffb37a0d.jpg";